export default {
  title: 'PayPal (direto)',
  description:
    'Ligue a sua conta empresarial PayPal para receber pagamentos PayPal diretamente, à sua taxa. Crie uma aplicação REST no PayPal Developer Dashboard e cole o Client ID e Secret abaixo.',
  connected_description: 'A sua conta PayPal está ligada. Os pagamentos serão liquidados diretamente nela.',
  guide: {
    title: 'Como obter as credenciais PayPal',
    step1: 'Inicie sessão no PayPal Developer Dashboard com a sua conta empresarial PayPal.',
    step2: 'Abra «Apps & Credentials» e crie uma aplicação (ou abra a existente).',
    step3: 'Copie o Client ID e o Secret da aplicação.',
    step4: 'Cole-os abaixo e clique em «Connect PayPal».',
    environment_note:
      'Use as credenciais Live para pagamentos reais — alterne o selector Sandbox/Live no topo de «Apps & Credentials».',
    open_dashboard: 'Abrir o PayPal Developer Dashboard',
  },
  status: {
    connected: 'Ligado',
  },
  fields: {
    client_id: {
      label: 'Client ID',
      placeholder: 'Client ID da sua aplicação REST PayPal',
    },
    client_secret: {
      label: 'Secret',
      placeholder: 'Secret da sua aplicação REST PayPal',
    },
  },
  buttons: {
    connect: 'Ligar PayPal',
    disconnect: 'Desligar',
  },
  toasts: {
    connected: 'PayPal ligado com sucesso',
    connect_failed: 'Não foi possível ligar o PayPal',
    disconnected: 'PayPal desligado',
    disconnect_failed: 'Não foi possível desligar o PayPal',
  },
};
